import { Subject } from "rxjs";

export type WidgetEvent =
  | { type: "LOGIN_CLICK" }
  | { type: "RELOGIN_CLICK" }
  | { type: "LOGOUT_CLICK" }
  | { type: "PROFILE_CLICK" }
  | { type: "CHAT_OPEN" }
  | { type: "CHAT_CONTINUE" }
  | { type: "CHAT_CLOSE" };

export const WidgetEvent$ = new Subject<WidgetEvent>();
